<template>
  <div @mouseover="enter" @mouseleave="leave">
    <swiper
      ref="swiperContainer"
      class="swiper-wrapper"
      :options="swiperOption"
    >
      <swiper-slide
        v-for="(image, idx) in imageList"
        :key="`swiper-item__${idx}`"
        class="swiper-slide"
      >
        <tk-image
          :image-path="image"
          class="tourHotelSelectRoom_reserve-hotelImage"
          @error="setAltImage"
        />
      </swiper-slide>
      <div v-if="imageList.length === 0" class="swiper-slide">
        <img
          :src="noImage"
          alt="hotel image"
          class="tourHotelSelectRoom_reserve-hotelImage"
        />
      </div>
      <div slot="button-prev" class="swiper-button-prev" @click="prevClick">
        <tk-icon :name="prevIcon" />
      </div>
      <div slot="button-next" class="swiper-button-next" @click="nextClick">
        <tk-icon :name="nextIcon" />
      </div>
    </swiper>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import noImage from '@ota-frontend/shared-assets/images/common/noimage.jpg'
import TkIcon from '../TkIcon/TkIcon.vue'
import TkImage from '../TkImage/TkImage.vue'

export default {
  name: 'TkImageSwiper',
  components: {
    TkIcon,
    TkImage,
    Swiper,
    SwiperSlide,
  },
  props: {
    imageList: {
      type: Array,
      required: true,
    },
    nextIcon: {
      type: String,
      required: false,
      default: 'swiper_arrow_right',
    },
    prevIcon: {
      type: String,
      required: false,
      default: 'swiper_arrow_left',
    },
    swiperOptions: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      noImage: noImage,
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  computed: {},
  beforeMount() {
    this.addSwiperOption()
  },
  mounted() {
    if (
      this.swiperOption.autoplay &&
      this.swiperOption.autoplay.initState === 'stop'
    ) {
      this.$refs.swiperContainer.$swiper.autoplay.stop()
    }
  },
  methods: {
    addSwiperOption() {
      for (const key in this.swiperOptions) {
        this.$set(this.swiperOption, key, this.swiperOptions[key])
      }
    },
    slideTo(idx) {
      this.$refs.swiperContainer.$swiper.slideTo(idx)
    },
    setAltImage(event) {
      event.target.src = noImage
    },
    enter(event) {
      this.$emit('enter', { event, container: this.$refs.swiperContainer })
    },
    leave(event) {
      this.$emit('leave', { event, container: this.$refs.swiperContainer })
    },
    prevClick(ev) {
      if (this.swiperOption.autoplay) {
        this.$refs.swiperContainer.$swiper.autoplay.stop()
        this.$refs.swiperContainer.$swiper.slidePrev()
      }
    },
    nextClick(ev) {
      if (this.swiperOption.autoplay) {
        this.$refs.swiperContainer.$swiper.autoplay.stop()
        this.$refs.swiperContainer.$swiper.slideNext()
      }
    },
  },
}
</script>

<style scoped>
.swiper-button-prev:after,
.swiper-button-next:after {
  content: '';
}
</style>
